const links = document.querySelectorAll('a[href^="#"]');

for (let link of links) {
    link.addEventListener('click', clickHandler);
}

function clickHandler(event) {
    event.preventDefault();

    let href = this.getAttribute('href');
    let headerHeight = 0; // Set default header height to 0
    let fixedHeaderElements = document.querySelectorAll('[data-fixed-header]:not(.invisible)');

    // Add headerHeight per fixed element
    [].forEach.call(fixedHeaderElements, function (fixedHeaderElement) {
        headerHeight += fixedHeaderElement.offsetHeight;
    });

    // Set offset
    let offsetTop = document.querySelector(href).offsetTop - headerHeight;

    // Scroll to anchor
    scroll({
        top: offsetTop,
        behavior: 'smooth'
    });

    if (g_dev === true) {
        console.log('Gescrollt naar "' + this.getAttribute('href') + '" met scroll positie "' + headerHeight + 'px".');
    }

    // Update scroll position after 175ms
    setTimeout(function () {
        let headerHeightNew = 0;

        [].forEach.call(fixedHeaderElements, function (fixedHeaderElement) {
            headerHeightNew += fixedHeaderElement.offsetHeight;
        });

        if (headerHeight !== headerHeightNew) {
            offsetTop = document.querySelector(href).offsetTop - headerHeightNew;
            scroll({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    }, 175);
}
